export const backgroundColorList = [
    "#67e265", "#d84f19", "#558693", "#a326e5", "#c2221f",
    "#0984a2", "#e93d51", "#fedcc5", "#9385f7", "#cc3b4d",
    "#74b5fc", "#9c475e", "#18b319", "#5533cf", "#b4a369",
    "#1819c5", "#e29edb", "#64625a", "#790a17", "#2542b4"
];

export function getCourseOccupancyData(courseList, courseRegistrationList) {
    const courseMap = {};
    const result = courseList.reduce((acc, course) => {
        courseMap[course._id] = course.code;
        acc.capacityArea[course._id] = course.capacity;
        acc.interestedArea[course._id] = 0;
        acc.alternate[course._id] = 0;
        acc.notAlternate[course._id] = 0;
        return acc;
    }, {
        capacityArea: {},
        interestedArea: {},
        notAlternate: {},
        alternate: {}
    });

    (courseRegistrationList || []).forEach(courseRegistration => {
        result.interestedArea[courseRegistration.course._id]++;
        if (courseRegistration.isAlternate) result.alternate[courseRegistration.course._id]++;
        else if (courseRegistration.isAlternate === false) result.notAlternate[courseRegistration.course._id]++;
    });

    const toArea = (obj) => Object.entries(obj).map(([courseId, value]) => ({
        y: value, label: courseMap[courseId]
    }));

    return {
        capacityArea: toArea(result.capacityArea),
        interestedArea: toArea(result.interestedArea),
        alternate: toArea(result.alternate),
        notAlternate: toArea(result.notAlternate)
    };
}

export function getTestResultDataPoints(testResultMap) {
    const data = Object.values(testResultMap || {})
        .reduce((acc, result) => {
            acc[result.result] ? acc[result.result]++ : (acc[result.result] = 1);
            return acc;
        }, {});
    return Object.entries(data).map(([key, val]) => ({
        x: Number(key),
        y: val
    }))
        .sort((a, b) => a.x - b.x);
}

export function getTestQuestionMaxPoints(testQuestionList) {
    const testResultPoints = {};
    const testQuestionMaxPoints = (testQuestionList || [])
        .filter(t => t.testType === "sortingTest")
        .reduce((acc, testQuestion) => {
            let testQuestionPointsCount = 0;
            if (testQuestion.type === 1) {
                // otevřená – součet evaluation (pokud takto definujete)
                testQuestionPointsCount = (testQuestion.answerList || [])
                    .reduce((sum, answer) => sum + (answer.evaluation || 0), 0);
            } else if (testQuestion.type === 0) {
                // výběr – maximum z evaluation
                const vals = (testQuestion.answerList || [])
                    .map(a => a.evaluation)
                    .filter(Boolean);
                testQuestionPointsCount = vals.length ? Math.max(...vals) : 0;
            }

            const testIdx = testQuestion.test;
            testResultPoints[testIdx] = (testResultPoints[testIdx] || 0) + testQuestionPointsCount;
            return acc + testQuestionPointsCount;
        }, 0);

    return {testResultPoints, testQuestionMaxPoints};
}
